import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { BiEdit, BiShowAlt, BiHide } from "react-icons/bi";
import { AiOutlineCheck, AiOutlineClose, AiOutlineRight } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";
import { CategoryService } from "./Services/CategoryService";
import CategoryModal from "./CategoryModal";

const ListCategory = () => {
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));

  const [categories, setCategories] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pendingSearch, setPendingSearch] = useState("");
  const [searchText, setSearchText] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [activeId, setActiveId] = useState(null);

  const loadCategories = async (p = page, s = pageSize, search = searchText) => {
    try {
      const res = await CategoryService.getPaged(p, s, search);
      setCategories(res.Data);
      setTotalRows(res.Total);
      setPage(p);
      setPageSize(s);
    } catch {
      toast.error("Failed to load categories");
    }
  };

  const openAdd = () => {
    setActiveId(null);
    setShowModal(true);
  };

  const openEdit = (id) => {
    setActiveId(id);
    setShowModal(true);
  };

  const togglePublish = async (id) => {
    try {
      await CategoryService.togglePublish(id);
      toast.success("Status updated");
      loadCategories();
    } catch {
      toast.error("Action failed");
    }
  };

  useEffect(() => {
    if (!Cookies.get("UserToken")) return;
    loadCategories();
  }, []);

  const columns = useMemo(() => [
    { name: "ID", selector: r => r.CategoryId, sortable: true },
    { name: "Category Name", selector: r => r.CategoryName, sortable: true },
    {
      name: "Published",
      cell: r => r.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
      center: true
    },
    {
      name: "Actions",
      cell: r => (
        <div className="d-flex gap-2">
          {permissions.ManageCategory && (
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => openEdit(r.CategoryId)}
            >
              <BiEdit />
            </button>
          )}
          {permissions.PublishCategory && (
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => togglePublish(r.CategoryId)}
            >
              {r.IsPublished ? <BiHide /> : <BiShowAlt />}
            </button>
          )}
        </div>
      )
    }
  ], [permissions]);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <h2>List Categories</h2>
        <ul className="portalPath">
          <li>Home <AiOutlineRight /></li>
          <li>List Categories</li>
        </ul>

        <div className="card">
          <div className="card-body">

            {/* SEARCH + ADD (same as slides) */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-8">
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Search categories..."
                    value={pendingSearch}
                    onChange={e => setPendingSearch(e.target.value)}
                    onKeyDown={e => {
                      if (e.key === "Enter") {
                        setSearchText(pendingSearch);
                        loadCategories(1, pageSize, pendingSearch);
                      }
                    }}
                  />
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                      setSearchText(pendingSearch);
                      loadCategories(1, pageSize, pendingSearch);
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>

              <div className="col-md-4 text-end">
                {permissions.ManageCategory && (
                  <button className="btn btn-primary" onClick={openAdd}>
                    + Add Category
                  </button>
                )}
              </div>
            </div>

            <DataTable
              columns={columns}
              data={categories}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={p => loadCategories(p, pageSize)}
              onChangeRowsPerPage={(s, p) => loadCategories(p, s)}
              highlightOnHover
              responsive
            />
          </div>
        </div>

        <CategoryModal
          show={showModal}
          categoryId={activeId}
          onClose={() => setShowModal(false)}
          onSaved={loadCategories}
        />

        <ToastContainer position="top-right" autoClose={5000} hideProgressBar />
      </div>
    </div>
  );
};

export default ListCategory;
